import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import './UpdatesPage.css';

function UpdatesPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Updates'; }, []);

  // Mock data for alerts - you can replace with real data
  const alerts = [
    {
      id: 1,
      type: 'email',
      priority: 'high',
      title: 'Email importante de cliente VIP',
      description: 'Juan Pérez requiere respuesta urgente sobre propuesta comercial',
      time: '5 min ago',
      icon: '✉️',
      color: 'blue',
      source: 'Gmail'
    },
    {
      id: 2,
      type: 'finance',
      priority: 'medium',
      title: 'Gasto inusual detectado',
      description: 'Transacción de $850 en categoría "Entretenimiento" excede promedio mensual',
      time: '1 hour ago',
      icon: '💰',
      color: 'orange',
      source: 'Finance Tracker'
    },
    {
      id: 3,
      type: 'task',
      priority: 'high',
      title: 'Tarea vencida',
      description: 'Completar presentación para reunión del martes',
      time: '2 hours ago',
      icon: '📋',
      color: 'red',
      source: 'Task Manager'
    },
    {
      id: 4,
      type: 'automation',
      priority: 'low',
      title: 'Workflow completado exitosamente',
      description: 'Backup automático de documentos ejecutado sin errores',
      time: '3 hours ago',
      icon: '🔄',
      color: 'green',
      source: 'n8n Monitor'
    },
    {
      id: 5,
      type: 'news',
      priority: 'medium',
      title: 'Noticia relevante detectada',
      description: 'Actualización importante en herramientas de productividad',
      time: '4 hours ago',
      icon: '📰',
      color: 'purple',
      source: 'News Aggregator'
    },
    {
      id: 6,
      type: 'calendar',
      priority: 'high',
      title: 'Reunión en 30 minutos',
      description: 'Video call con equipo de desarrollo - Sala zoom 123',
      time: '30 min from now',
      icon: '📅',
      color: 'blue',
      source: 'Calendar'
    }
  ];

  const priorityStats = {
    high: alerts.filter(alert => alert.priority === 'high').length,
    medium: alerts.filter(alert => alert.priority === 'medium').length,
    low: alerts.filter(alert => alert.priority === 'low').length
  };

  // Filter alerts based on search term
  const filteredAlerts = alerts.filter(alert =>
    alert.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    alert.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    alert.source.toLowerCase().includes(searchTerm.toLowerCase()) ||
    alert.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMarkAsRead = (alertId) => {
    console.log('Marking alert as read:', alertId);
    // Implement mark as read functionality
  };

  const handleCreateAlert = () => {
    console.log('Creating new alert');
    // Implement create alert functionality
  };

  return (
    <div className="updates-page">
      <Header 
        currentPage="updates" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={handleCreateAlert}
      />

      <div className="updates-content">
        {/* Priority Stats */}
        <div className="priority-stats">
          <div className="stat-card high">
            <div className="stat-icon">🚨</div>
            <div className="stat-content">
              <h3>{priorityStats.high}</h3>
              <p>Alta Prioridad</p>
            </div>
          </div>
          <div className="stat-card medium">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <h3>{priorityStats.medium}</h3>
              <p>Media Prioridad</p>
            </div>
          </div>
          <div className="stat-card low">
            <div className="stat-icon">ℹ️</div>
            <div className="stat-content">
              <h3>{priorityStats.low}</h3>
              <p>Baja Prioridad</p>
            </div>
          </div>
          <div className="stat-card total">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <h3>{alerts.length}</h3>
              <p>Total Alertas</p>
            </div>
          </div>
        </div>

        {/* Alerts List */}
        <div className="alerts-section">
          <div className="section-header">
            <h2>Alertas Recientes ({filteredAlerts.length})</h2>
            <div className="section-actions">
              <button className="btn-secondary">Marcar Todas Leídas</button>
              <button className="btn-secondary">Filtros</button>
            </div>
          </div>

          <div className="alerts-list">
            {filteredAlerts.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">🔍</div>
                <h3>No se encontraron alertas</h3>
                <p>Intenta ajustar los términos de búsqueda o crear una nueva alerta</p>
              </div>
            ) : (
              filteredAlerts.map((alert) => (
                <div key={alert.id} className={`alert-card ${alert.priority} ${alert.color}`}>
                  <div className="alert-header">
                    <div className="alert-icon">
                      <span>{alert.icon}</span>
                    </div>
                    <div className="alert-meta">
                      <div className="alert-source">{alert.source}</div>
                      <div className="alert-time">{alert.time}</div>
                    </div>
                    <div className={`priority-badge ${alert.priority}`}>
                      {alert.priority}
                    </div>
                  </div>
                  <div className="alert-content">
                    <h4>{alert.title}</h4>
                    <p>{alert.description}</p>
                  </div>
                  <div className="alert-actions">
                    <button 
                      className="btn-action primary"
                      onClick={() => handleMarkAsRead(alert.id)}
                    >
                      Marcar Leída
                    </button>
                    <button className="btn-action secondary">Ver Detalles</button>
                    <button className="btn-action danger">Descartar</button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions-section">
          <h2>Acciones Rápidas</h2>
          <div className="quick-actions-grid">
            <div className="quick-action-card">
              <div className="action-icon">✉️</div>
              <h3>Revisar Emails</h3>
              <p>Emails importantes pendientes</p>
              <button className="btn-primary">Ir a Emails</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">📋</div>
              <h3>Tareas Pendientes</h3>
              <p>Tareas con vencimiento próximo</p>
              <button className="btn-primary">Ver Tareas</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">💰</div>
              <h3>Estado Financiero</h3>
              <p>Resumen de gastos e ingresos</p>
              <button className="btn-primary">Ver Finanzas</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">🔄</div>
              <h3>Automatizaciones</h3>
              <p>Monitor de workflows activos</p>
              <button className="btn-primary">Ver Monitor</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatesPage;
